import { render, staticRenderFns } from "./CategoryDrugs.vue?vue&type=template&id=6006c90b&scoped=true"
import script from "./CategoryDrugs.vue?vue&type=script&lang=js"
export * from "./CategoryDrugs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6006c90b",
  null
  
)

export default component.exports